import React from "react";
import cx from "classnames";

import "./ActionButton.scss";
import { dataTestIds } from "data-testids";

export interface IActionButtonProps {
  /** SVG icon component to render */
  svgIcon?: React.ReactNode;
  /** What to do when clicking */
  onClick: (
    event:
      | React.MouseEvent<HTMLAnchorElement>
      | React.KeyboardEvent<HTMLAnchorElement>
  ) => void;
  /** Optional label */
  label?: string;
  /** Optional label for screen readers */
  ariaLabel?: string;
  /** Optional disabled status */
  disabled?: boolean;
  /** Optional css class for the topmost div */
  className?: string;
  /** Optional class modifier for button size if it is differs from standard one */
  size?: "xs" | "small";
  /** Option for pre-designed variants; add mroe as necessary */
  variant?: "toolbar";
}

export class ActionButton extends React.Component<IActionButtonProps> {
  public render() {
    const {
      disabled,
      className,
      onClick,
      svgIcon,
      label,
      ariaLabel,
      size,
      variant,
    } = this.props;

    return (
      <div
        className={cx("c-action-button", className, {
          disabled,
          [`c-action-button--${size}`]: size,
          [`c-action-button--${variant}`]: variant,
        })}
      >
        <a
          role="button"
          aria-disabled={disabled}
          className="c-action-button-holder"
          tabIndex={disabled ? -1 : 0}
          onClick={onClick}
          onKeyPress={onClick}
          data-testid={
            dataTestIds.componentLibrary["Atoms.ActionButton.buttonDiv"]
          }
        >
          <div className="c-action-button-icon">{svgIcon}</div>
          <div className="c-action-button-label" aria-label={ariaLabel}>
            {label}
          </div>
        </a>
      </div>
    );
  }
}
